import { render, staticRenderFns } from "./ReviewBankcard.vue?vue&type=template&id=700a2d96&scoped=true"
import script from "./ReviewBankcard.vue?vue&type=script&lang=js"
export * from "./ReviewBankcard.vue?vue&type=script&lang=js"
import style0 from "./ReviewBankcard.vue?vue&type=style&index=0&id=700a2d96&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "700a2d96",
  null
  
)

export default component.exports